// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"c7864d76","80":"00b7007d","218":"e67d6d55","373":"17d6d80e","488":"2f533580","528":"258afc15","577":"cbc8dab1","884":"3a227f00"}[chunkId] + ".chunk.js";
};